var React = require('react');
var Router = require('react-router');

var Invocation = require('../../api/Invocation');

var CpanelRedirect = React.createClass({
    mixins: [Router.State],

    componentWillMount: function () {
        Invocation.hosting.getAutoLoginUrl(this.props.params.serviceId)
            .then(function (response) {
                window.location = response.body.url;
            })
            .done();
    },

    render: function () {
        return <section id="portal" className="colorful-page-wrapper">
            <div className="center-block">
                <div className="login-block">
                    <header>
                        <p><i className="fa fa-spinner fa-spin"></i> Infinite Portal</p>
                    </header>
                    <fieldset>
                        <p>Redirecting you to cPanel, please wait ...</p>
                    </fieldset>
                </div>
            </div>
        </section>;
    }
});
module.exports = CpanelRedirect;



// WEBPACK FOOTER //
// ./app/components/ClientService/CpanelRedirect.js